import React from 'react'

import './Banner.scss'

import { Img } from '@components/shared/elements'

class Banner extends React.Component {

  // constructor(props) {
  //   super(props)
  // }
  
  render() {
    return (
      <section className={`${this.props.variationClass3 === 'contact' ? '' : 'banner'} ${this.props.variationClass}`}>
        <figure className={this.props.variationClass2}>
          {this.props.image &&
            <Img src={this.props.image} alt='destaque' />
          }
          <figcaption>
            {this.props.children}
          </figcaption>
        </figure>
      </section>
    )
  }
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/shared/elements/Banner/Banner.js